export const bpBase = 10000n;
export const MAX_UINT256 = 2n ** 256n - 1n;
export const MAX_UINT160 = 2n ** 160n - 1n;
export const DEFAULT_GAS_LIMIT = 580000n;
export const ERC20_TRANSFER_GAS = 65000n;
//# sourceMappingURL=unit.js.map